import React from 'react';
import { ImageIcon } from 'lucide-react';
interface PendingArtworkProps {
  label: string;
  className?: string;
}

/** Neutral slot shown until the real product artwork is supplied. */
export function PendingArtwork({
  label,
  className = ''
}: PendingArtworkProps) {
  return <div role="img" aria-label={label} className={`flex flex-col items-center justify-center gap-2 border border-dashed border-brand-line bg-brand-ivory p-4 text-center ${className}`} data-id="element-202" data-mp="358iqfrbz6w4j">
      <ImageIcon className="h-6 w-6 text-brand-navy/40" strokeWidth={1.5} aria-hidden="true" data-id="element-203" data-mp="2cjlkmnoyarso" />
      <span className="max-w-[18rem] text-[11px] font-semibold leading-snug text-slate-600" data-id="element-204" data-mp="2hj80z602so5p">{label}</span>
    </div>;
}